<!-- Details of failure -->
<div *ngIf="requestFailed() && !isLoading()">
  <div class="label medium-margin">
    <p>{{failureMsg}}</p>
  </div>
  <div class="status-grid">
    <div class="status-grid-item-logo" *ngIf="isCloudBased()">
      <logo-widget
        [serviceUrl]="step.parent.output.url"
        [styleInfo]="'logo-64-wide'"
        [defaultUrl]="'images/services.svg'"
      ></logo-widget>
    </div>
    <div class="status-grid-item-logo" *ngIf="isOnPremise()">
      <div class="app-logo" >
        <i class="material-icons premise-app-icon--noborder">location_city</i>
      </div>
    </div>
    <div class="status-grid-item">
      <div>{{ step.parent.output.name }} application</div>
      <div class="error-color status-row">
        <span><i class="status-grid-status-icon material-icons error-icon error-color">clear</i></span>
        {{wizardCtrl.wizardService.errorDescription}}
      </div>
    </div>
  </div>

  <!--<div class="retry-container">
    Reason for failure
    <ul>
      <li>{{wizardCtrl.wizardService.errorMessage}}</li>
    </ul>
    <button
      mat-raised-button
      class="btn btn-blue"
      (click)="wizardCtrl.retryOperation()"
    >
      TRY AGAIN
    </button>
  </div>-->
</div>

<!-- Details of success -->
<div  *ngIf="!requestFailed() && !isLoading()">
  <div class="label medium-margin row--centered">
    <p>{{successMsg}}</p>
  </div>
  <div class="status-grid">
    <div class="status-grid-item-logo" *ngIf="isCloudBased()">
      <logo-widget
        [serviceUrl]="step.parent.output.url"
        [styleInfo]="'logo-64-wide'"
        [defaultUrl]="'images/services.svg'"
      ></logo-widget>
    </div>
    <div class="status-grid-item-logo" *ngIf="isOnPremise()">
      <div class="app-logo" >
        <i class="material-icons premise-app-icon--noborder">location_city</i>
      </div>
    </div>
    <div class="status-grid-item">
      <div>{{ step.parent.output.name }} Application</div>
      <div class="success-color status-row">
        <span><i class="status-grid-status-icon material-icons success-color success-icon">done</i></span>
        {{successFlag}}
      </div>
    </div>
  </div>
  <div class="medium-margin flex-centered mt-4" *ngIf="isOnPremise()">
    You can now close this wizard or create additional application tiers
    <button mat-raised-button class="mt-2 btn btn-blue btn--auto-width" (click)="wizardCtrl.launchApplicationTiers()">
      ADD APPLICATION TIER
    </button>
  </div>
</div>
<div *ngIf="isLoading()" class="flex-centered">
  <div class="label medium-margin"><p>Retrying</p></div>
  <mat-spinner></mat-spinner>
  <div class="label medium-margin">One moment...</div>
</div>
